import QrCodeWithLogo from "qrcode-with-logos";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const USSDContributionSection = ({ groupId }) => {
  const { t } = useTranslation();

  useEffect(() => {
    new QrCodeWithLogo({
      content: `tel:*528*1*${groupId}%23`,
      width: 220,
      image: document.getElementById("qrcode"),
      // logo: {
      //   src: "/qr-image.png",
      //   logoSize: 0.24,
      // borderSize: 0,
      // },
    });
  });

  return (
    <div>
      <h2 className="font-bold text-xl">
        {t("contribution-page.contribute-ussd")}
      </h2>
      <p className="my-4">
        {t("contribution-page.ussd-code.step1")}{" "}
        <a href={`tel:*528*1*${groupId}%23`} className="text-[#2576D6]">
          *528*1*{groupId}#
        </a>{" "}
        {t("contribution-page.ussd-code.step2")}
      </p>
      <img src={""} id="qrcode" alt="qrcode" />
    </div>
  );
};

export default USSDContributionSection;
